import type { ChangeEventHandler, Ref } from "react";

export function PhotoFileInput({
  ref,
  accept,
  multiple,
  onChange,
}: {
  ref: Ref<HTMLInputElement>;
  accept: string;
  multiple?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
}) {
  return (
    <input
      ref={ref}
      type="file"
      accept={accept}
      multiple={multiple}
      aria-label="Upload product photos"
      tabIndex={-1}
      className="sr-only"
      onChange={onChange}
    />
  );
}
